import React from 'react'
import TradeMark from '../tradeMark/TradeMark'

import '../../styles/scss/components/equote-package-details-footer.scss'

const EQuotePackageDetailsFooter = () => {
  return (
    <div className="equote__package-details-footer">
      <div className="equote__package-details-footer-container">
        <p className="equote__package-details-footer-rights">
          <TradeMark />
        </p>

        <div className="equote__package-details-footer-links">
          <div
            className="equote__package-details-footer-link btn"
            style={{ cursor: 'default' }}
          >
            Privacy Policy
          </div>
        </div>
      </div>
    </div>
  )
}

export default EQuotePackageDetailsFooter
